const INTERNATIONAL_URL = process.env.NEXTINTERNATION_URL || 'https://www.kamaayurveda.com';
const INDIAN_URL = process.env.NEXTAUTH_URL || 'https://www.kamaayurveda.in';

const hreflangs = {
    "/": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/`
      }
    ],
    "/about-ayurveda": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/history-of-ayurveda`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/history-of-ayurveda`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/about-ayurveda`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/history-of-ayurveda`
      }
    ],
    "/about-us": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/the-story`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/the-story`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/about-us`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/the-story`
      }
    ],
    "/checkout/cart": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/cart`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/cart`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/checkout/cart`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/cart`
      }
    ],
    "/customer/account/create": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/login/register`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/login/register`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/customer/account/create`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/login/register`
      }
    ],
    "/customer/account/login": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/login`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/login`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/customer/account/login`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/login`
      }
    ],
    "/kama-is-kind": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/sustainability-commitments`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/sustainability-commitments`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/kama-is-kind`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/sustainability-commitments`
      }
    ],
    "/privacy-policy": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/privacy-policy`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/privacy-policy`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/privacy-policy`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/privacy-policy`
      }
    ],
    "/promotion": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/promotion-terms-and-conditions`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/promotion-terms-and-conditions`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/promotion`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/promotion-terms-and-conditions`
      }
    ],
    "/returns-refunds": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/returns-and-refunds-policy`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/returns-and-refunds-policy`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/returns-refunds`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/returns-and-refunds-policy`
      }
    ],
    "/store": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/store-finder`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/store-finder`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/store`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/store-finder`
      }
    ],
    "/terms-conditions": [
      {
        "hreflang": "en-GB",
        "url": `${INTERNATIONAL_URL}/uk/en_GB/terms-and-conditions`
      },
      {
        "hreflang": "en",
        "url": `${INTERNATIONAL_URL}/ww/en/terms-and-conditions`
      },
      {
        "hreflang": "en-IN",
        "url": `${INDIAN_URL}/terms-conditions`
      },
      {
        "hreflang": "x-default",
        "url": `${INTERNATIONAL_URL}/ww/en/terms-and-conditions`
      }
    ]
};

export default hreflangs;